import { clientHttp } from '@/shared/api/client'
import { CLIENT_API_ENDPOINTS } from '@/shared/lib'

import { type IMycleContentDetailResponse } from '../../model'

export const getMycleContentDetail = async (
  contentId: number
): Promise<IMycleContentDetailResponse> => {
  return await clientHttp.get(CLIENT_API_ENDPOINTS.CAR_STORY.DETAIL(contentId))
}
